var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.getDay)+" "+_vm._s(_vm.$t((_vm.short ? 'monthShort' : 'monthNameNum') + '.'+_vm.getMonth))+" "+_vm._s(_vm.getYear)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }